import { useEffect, useState } from "react";
import { microphone_onboarding, microphone_screen } from "../../../NewConstants/MicrophnoeOnboardingConstants";

const ImagePreloader = ({ src }) => {
    useEffect(() => {
        const img = new Image();
        img.src = src;
    }, [src]);

    return null;
};

const MicropohneOnboarding = ({ selectedLanguageCode, onboarding_delay }) => {
    const [screenIndex, setScreenIndex] = useState(microphone_onboarding["seconds"]);
    const imageUrls = [
        `/public/Assets/Images/mic_onboarding_1.png`,
        `/public/Assets/Images/mic_onboarding_2.png`,
        `/public/Assets/Images/mic_onboarding_3.png`,
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setScreenIndex((prevIndex) => prevIndex - 1)
        }, onboarding_delay);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <>
            {imageUrls.map((url, index) => (
                <ImagePreloader key={index} src={url} />
            ))}
            <div className="z-30 fixed inset-0 bg-gray-800 opacity-50"></div>
            <div className="z-30 bg-[var(--neutral-white)] fixed left-0 bottom-0 w-full rounded-t-3xl flex  flex-col justify-between recorederBox leading-loose">
                <img className="m-4 mb-0 mic-onboarding-image" src={`/Assets/Images/mic_onboarding_${screenIndex}.png`} alt="mic" />
                <div className="flex flex-col items-center my-4 justify-center">
                    <div className="text-2xl font-bold mic-onboarding-title">
                        {microphone_screen[screenIndex]?.[selectedLanguageCode]}
                    </div>
                    {screenIndex > 0 && <div className="text-[12vh] font-thin">
                        {screenIndex}
                    </div>}
                    <div className="text-xl text-[var(--dark-neutral-2)]">
                        {microphone_onboarding["title"][selectedLanguageCode]}
                    </div>
                </div>
            </div>
        </>
    );
}

export default MicropohneOnboarding;
